import axios, { AxiosResponse } from "axios";
import { RespuestaPostGrado } from "../interfaces/PostGrado/ResponsePost";
import { Programa } from "../interfaces/Programa";
const SERVICE : string = process.env.REACT_APP_POSTGRADO || ''; 
const APIPROGRAMA : string = 'Programa/';
//calendar/142

export default class PostGradoServices{

    async GetProgramaPostgrados(token:any): Promise<any> {
        //console.log(SERVICE+APIPROGRAMA+'consultaProgramasAcademicosVigentes');
        const response1:AxiosResponse<any> = await axios.get(SERVICE+APIPROGRAMA+'consultaProgramasAcademicosVigentes',{
            headers: {
              Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }
}